var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstateLandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 128,
    viewBox: "0 0 228 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illus-terrainconstruction"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.43 66.0858H116.306C115.111 66.0858 114.315 65.2895 114.315 64.0951C114.315 62.9008 115.111 62.1045 116.306 62.1045H132.43C133.625 62.1045 134.421 62.9008 134.421 64.0951C134.421 65.2895 133.625 66.0858 132.43 66.0858Z",
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5426 78H27.3482C25.8301 78 24.4428 78.8594 23.7667 80.2186L2.87571 122.219C1.55306 124.878 3.48723 128 6.45713 128H221.238C224.28 128 226.208 124.739 224.743 122.074L201.664 80.0736C200.961 78.7947 199.618 78 198.158 78H187.593",
    fill: "#92C281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4_2",
    d: "M44.8001 88.291H33.3809L17.6204 120.974H208.047L191.781 88.291H180.981",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.9 5.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5628 109.8H169.047C170.116 109.8 170.829 109.087 170.829 108.018C170.829 106.949 170.116 106.236 169.047 106.236H165.305V81.1095C165.305 80.0403 164.592 79.3275 163.523 79.3275H156.395V30.6789H158.177C159.246 30.6789 159.959 29.9661 159.959 28.8969V21.2343H168.69C169.76 21.2343 170.472 20.5215 170.472 19.4523V9.1167C170.472 8.0475 169.76 7.3347 168.69 7.3347H159.959V3.2361C159.959 2.1669 159.246 1.4541 158.177 1.4541H138.04C136.971 1.4541 136.258 2.1669 136.258 3.2361V5.9091H85.8274C85.2928 5.9091 84.7582 6.0873 84.58 6.4437L71.5714 19.4523C71.0368 19.9869 70.8586 20.6997 71.215 21.4125C71.5714 22.1253 72.106 22.4817 72.8188 22.4817H84.0454V35.3121L58.2064 54.2013C57.6718 54.7359 57.3154 55.4487 57.4936 56.1615C57.6718 56.8743 58.3846 57.4089 59.2756 57.4089H112.557C113.27 57.4089 113.983 56.8743 114.339 56.1615C114.518 55.4487 114.339 54.5577 113.627 54.2013L87.6094 35.3121V22.6599H136.258V29.0751C136.258 30.1443 136.971 30.8571 138.04 30.8571H139.644V79.5057H132.516C131.447 79.5057 130.734 80.2185 130.734 81.2877V106.414H107.211V67.3881C107.211 66.3189 106.499 65.6061 105.429 65.6061H66.2254C65.1562 65.6061 64.4434 66.3189 64.4434 67.3881V106.236H58.5628C57.4936 106.236 56.7808 106.949 56.7808 108.018C56.7808 109.087 57.4936 109.8 58.5628 109.8ZM159.78 10.8987H166.73V17.8485H159.78V10.8987ZM125.922 9.6513L136.258 17.3139V9.6513H125.922ZM115.409 9.4731L105.073 17.1357V9.4731H115.409ZM91.1734 9.6513L101.509 17.3139V9.6513H91.1734ZM84.0454 19.0959H77.0956L84.0454 12.1461V19.0959ZM85.8274 38.3415L64.6216 53.8449H107.033L85.8274 38.3415ZM87.6094 11.2551L97.945 18.9177H87.6094V11.2551ZM118.973 11.4333L108.637 19.0959H118.973V11.4333ZM122.537 11.2551L132.872 18.9177H122.537V11.2551ZM143.208 30.6789V79.3275H152.652V30.6789H143.208ZM78.6994 106.236V94.1181C78.6994 90.1977 81.907 86.9901 85.8274 86.9901C89.7478 86.9901 92.9554 90.1977 92.9554 94.1181V106.236H78.6994ZM161.741 82.8915H134.298V106.236H161.741V82.8915Z",
    fill: "#120136"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M64 62H110V110H100.8V94.3077C100.8 86.6923 94.59 80.4615 87 80.4615C79.41 80.4615 73.2 86.6923 73.2 94.3077V110H64C64 110 64 62 64 62Z",
    fill: "#FFDC53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6995 106.236V94.1182C78.6995 90.1978 81.9071 86.9902 85.8275 86.9902C89.7479 86.9902 92.9555 90.1978 92.9555 94.1182V106.236H78.6995Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.741 78.2354H165.741V106.235H129.741V78.2354Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M139.822 5.01855H156.216V27.1154H139.822V5.01855V5.01855Z",
    fill: "#97AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.652 79.3273V30.6787H156.652V79.3273H138.652Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fenetre"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.272 78.474H73.62C72.81 78.474 72 77.826 72 76.854V76.692V76.53V67.62C72 66.648 72.648 66 73.62 66H97.272C97.596 66 97.92 66.162 98.244 66.324C98.892 66.486 99.378 67.134 99.378 67.782V76.53C99.378 77.34 98.73 77.988 98.082 78.15C97.92 78.312 97.596 78.474 97.272 78.474ZM91.602 75.234H96.3V69.24H91.602V75.234ZM88.2 75.234H83.34V69.24H88.2V75.234ZM75.24 75.234H80.1V69.24H75.24V75.234Z",
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1 75.2342H75.24V69.2402H80.1V75.2342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2001 75.2342H83.3401V69.2402H88.2001V75.2342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3001 75.2342H91.6021V69.2402H96.3001V75.2342Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 58L86 34L120 58H52Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 86,
    cy: 46,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8275 52.0631C82.9763 52.0631 80.6597 49.7465 80.6597 46.8953C80.6597 44.0441 82.9763 41.7275 85.8275 41.7275C88.6787 41.7275 90.9953 44.0441 90.9953 46.8953C90.9953 49.7465 88.6787 52.0631 85.8275 52.0631ZM87.4313 46.8953C87.4313 46.0043 86.7185 45.2915 85.8275 45.2915C84.9365 45.2915 84.2237 46.0043 84.2237 46.8953C84.2237 47.7863 84.9365 48.4991 85.8275 48.4991C86.7185 48.4991 87.4313 47.7863 87.4313 46.8953Z",
    fill: "#1E1548"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstateLandIcon);
export default __webpack_public_path__ + "static/media/estate-land-icon.52b5c89f.svg";
export { ForwardRef as ReactComponent };